"use client"

import { router, usePage } from "@inertiajs/react"
import { LogOut01, Settings01 } from "@untitledui/icons"

import { AvatarLabelGroup } from "@/components/ui/avatar-label-group"
import { Dropdown } from "@/components/ui/dropdown-menu"
import { sessionPath, settingsProfilePath } from "@/routes"

/*
 * The signed-in person at the foot of the rail: the Avatar label group on print,
 * a photograph when the user has one and initials when not.
 * The shared auth prop carries no photograph today, so this is initials until
 * it does. Opens the account menu.
 */
const initials = (name: string) =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase() ?? "")
    .join("")

export const UserChip = () => {
  const { auth } = usePage().props
  const user = auth.user
  const session = auth.session

  if (!user) return null

  return (
    <Dropdown.Root>
      <Dropdown.Trigger className="hover:bg-onprint-hover flex w-full cursor-pointer items-center rounded-lg px-2 py-1.5 text-left outline-none focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-stone-50">
        <AvatarLabelGroup
          tone="print"
          size="sm"
          src={user.avatar}
          alt=""
          initials={initials(user.name)}
          title={user.name}
          subtitle={user.email}
        />
      </Dropdown.Trigger>

      <Dropdown.Popover>
        <Dropdown.Menu>
          <Dropdown.Item
            icon={Settings01}
            label="Settings"
            href={settingsProfilePath()}
          />
          <Dropdown.Separator />
          <Dropdown.Item
            icon={LogOut01}
            label="Log out"
            onAction={() => router.delete(sessionPath({ id: session.id }))}
          />
        </Dropdown.Menu>
      </Dropdown.Popover>
    </Dropdown.Root>
  )
}
